<template>
    <div>
        <span v-if="row.item.Status === 'Pending'">
            <b-badge variant="secondary">{{ row.item.Status }}</b-badge>
        </span>
        <span v-if="row.item.Status === 'Resolved'">
            <b-badge variant="primary">{{ row.item.Status }}</b-badge>
        </span>
    </div>
</template>

<script>
export default {
    name: 'discrepancy-report-row-status',
    props: {
        row: {
            type: Object,
            required: true
        }
    }
};
</script>